module.exports = __webpack_public_path__ + "static/media/articulate-logo.b9022e61.avif";